var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M11.967 17.185a2.782 2.782 0 01-3.934 0L4.549 13.7a1.875 1.875 0 112.652-2.652L10 13.848l7.299-7.299a1.876 1.876 0 012.652 2.652L12.652 16.5z"}})}
var staticRenderFns = []

export { render, staticRenderFns }